









import { Component, Prop, Vue } from "vue-property-decorator";
import ImageModel from "@/model/ImageModel";
import ImageStringModel from "@/model/ImageStringModel";
import AttemptModule from "@/store/AttemptModule";
@Component
export default class ImageString extends Vue {
  @Prop()
  contentValue!: string;

  get imageString(): ImageStringModel {
    const imageString = {
      parts: []
    } as ImageStringModel;
    const splitName = this.contentValue
      .split(/([{}])+/)
      .filter((e: string) => e);
    for (let i = 0; i < splitName.length; i++) {
      if (splitName[i] === "{") {
        imageString.parts.push(AttemptModule.imageBySlug(splitName[i + 1]));
        i += 2;
      } else {
        imageString.parts.push(splitName[i].toString());
      }
    }
    return imageString;
  }
}
